export default __webpack_public_path__ + "static/media/otp.1c41adc5.jpg";